"use strict";

module.exports = require("./TimestampHandler");